<template>
  <div>
    <CommonDialog
      :dialog="dialog"
      :head-text="$t(`${resource}.delete-title`)"
      :content-text="$t(`${resource}.delete-dialog`)"
      :confirm-button="{
        text: $t('tabs.delete'),
        icon: 'mdi-trash-can-outline'
      }"
      :on-confirm="deleteItem"
      :on-cancel="
        () => {
          dialog = false;
        }
      "
    ></CommonDialog>
    <v-row>
      <v-col cols="12">
        <h2>{{ $t(`${resource}.delete-title`) }}</h2>
        <p>{{ $t(`${resource}.delete-text`) }}</p>
        <v-btn
          color="primary"
          v-on:click="dialog = true"
          :loading="loading"
          :disabled="disabled"
        >
          <v-icon left>mdi-trash-can-outline</v-icon>
          {{ $t("tabs.delete") }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CommonDialog from "../dialogs/CommonDialog";
export default {
  name: "DeleteTab",
  props: {
    id: {
      type: String
    },
    resource: {
      type: String
    },
    dispatch: {
      type: String
    },
    routing: {
      type: [String, Object]
    },
    disabled: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  components: { CommonDialog },
  data: () => ({
    dialog: false,
    loading: false
  }),
  methods: {
    deleteItem() {
      this.loading = true;
      this.$store.dispatch(this.dispatch, {
        id: this.$props.id,
        params: this.params,
        onSuccess: () => {
          this.$router.push(
            typeof this.routing === "string"
              ? { name: this.routing }
              : this.routing
          );
        },
        onError: () => {
          this.loading = false;
        }
      });
      this.dialog = false;
    }
  }
};
</script>

<style scoped></style>
